module.exports = __webpack_public_path__ + "static/media/flc.c69a0556.png";